import React from "react"
import { PieAmchartSeeker } from "@ui-seeker/core"
import { useInfoBlockData } from "Pages/BusinessLogistics/Analytics/Page/@hooks"
import { Skeleton } from "@mui/material"


export default function EuropcarPieChart({ requestType }) {

	const { res, isLoading } = useInfoBlockData(requestType, true)


	if (isLoading) return <Skeleton variant="rectangular" height={400}/>


	return <PieAmchartSeeker
		rootID={`SearchAnalyticsPieChart-${requestType}`}
		data={res}
		series={[{
			yField: 'label',
			xField: "percentage",
			innerRadius: 60,
		}]}
		sx={{ height: 350 }}
		chartProps={{
			enabledPDF: false,
			chart: {
				horizontalLayout: true,
			},
			legend: {
				verticalLayout: true,
				labels: {
					maxWidth: 140,
					width: 140,
					oversizedBehavior: "wrap"
				},
				valueLabels: {
					textAlign: "right"
				}
			}
		}}

	/>
}